import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { ANIMATION_TYPES } from "ngx-loading";
@Component({
  selector: "shared-loading2",
  templateUrl: "./loading2.component.html",
  styleUrls: ["./loading2.component.scss"]
})
export class Loading2Component {
  constructor(private cdr: ChangeDetectorRef) {}

  config = {
    animationType: ANIMATION_TYPES.circleSwish,
    backdropBackgroundColour: "transparent",
    fullScreenBackdrop: false,
    primaryColour: "#00acb0",
    secondaryColour: "#00acb0",
    tertiaryColour: "#00acb0"
  };
  showLoader = false;
  isVisible = false;
  private hideTimeout: ReturnType<typeof setTimeout> | null = null;
  private showFrame: number | null = null;
  private showVisibleFrame: number | null = null;
  private _isLoading = false;

  @Input() public set isLoading(value: boolean) {
    this._isLoading = value;

    if (value) {
      this.clearHideTimeout();
      this.clearShowFrames();

      this.showLoader = true;
      // Delay isVisible so ngx-loading renders at opacity 0 first,
      // then the class triggers the CSS transition to opacity 1.
      this.showFrame = requestAnimationFrame(() => {
        this.showFrame = null;
        this.showVisibleFrame = requestAnimationFrame(() => {
          this.showVisibleFrame = null;
          if (!this._isLoading) {
            return;
          }

          this.isVisible = true;
          this.cdr.detectChanges();
        });
      });
      return;
    }

    this.clearShowFrames();
    this.isVisible = false;
    this.clearHideTimeout();

    this.hideTimeout = setTimeout(() => {
      if (this._isLoading) {
        return;
      }

      this.showLoader = false;
      this.hideTimeout = null;
      this.cdr.detectChanges();
    }, 150);
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  private clearHideTimeout(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  private clearShowFrames(): void {
    if (this.showFrame !== null) {
      cancelAnimationFrame(this.showFrame);
      this.showFrame = null;
    }

    if (this.showVisibleFrame !== null) {
      cancelAnimationFrame(this.showVisibleFrame);
      this.showVisibleFrame = null;
    }
  }
}
